/** Chrome's install event, which lib.dom does not declare. */
export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

type Listener = () => void;

let deferred: BeforeInstallPromptEvent | null = null;
let installedThisLoad = false;
const listeners = new Set<Listener>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

// Chrome fires `beforeinstallprompt` once per page load, so it must be captured
// at module scope, before React mounts: a listener that lives only while some
// component is mounted misses the event on every route that renders no install
// surface, and loses it again when that component unmounts on navigation.
window.addEventListener('beforeinstallprompt', (event) => {
  // Without preventDefault Chrome shows its own mini-infobar instead of ours.
  event.preventDefault();
  deferred = event as BeforeInstallPromptEvent;
  emit();
});

window.addEventListener('appinstalled', () => {
  installedThisLoad = true;
  deferred = null;
  emit();
});

export const installPromptStore = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getDeferred: (): BeforeInstallPromptEvent | null => deferred,
  wasInstalledThisLoad: (): boolean => installedThisLoad,
  /** The event is single use; drop it once consumed so no surface replays it. */
  clearDeferred(): void {
    deferred = null;
    emit();
  },
};
